// Copyright (c) 2024 by Audere

import { Box, Button, Stack, Typography } from "@mui/material";
import { createStyleSheet, globalStyles } from "../utils/styles";

import PageHeader from "../components/PageHeader";
import React from "react";
import { getBuildCommit } from "../../buildInfo";
import { useNavigate } from "react-router-dom";
import { useLabelingSchema } from "../hooks/useSchema";

const LabelTypeSelect: React.FC = () => {
  const navigate = useNavigate();
  const handleLabelTypeClick = (labelTypeID: string) => {
    navigate(`/dashboard/${labelTypeID}`);
  };

  const { labelingTypes } = useLabelingSchema();

  return (
    <Box sx={globalStyles.pageContainerColumn}>
      {/* Page header */}
      <Box flexShrink={0}>
        <PageHeader title="Labeling Dashboards" />
      </Box>

      {/* Main content */}
      <Box sx={styles.pageBody}>
        <Typography variant="h4" gutterBottom>
          Select a labeling type to begin.
        </Typography>

        {/* Dashboard buttons */}
        <Stack direction="row" spacing={2} sx={styles.labelTypesStack}>
          {labelingTypes.map((labelType) => (
            <Box key={labelType.id} sx={styles.buttonsBox}>
              <Button
                variant="contained"
                size="large"
                fullWidth
                onClick={() => {
                  handleLabelTypeClick(labelType.id);
                }}
              >
                {labelType.name}
              </Button>
              <Typography variant="subtitle1" textAlign="center" gutterBottom>
                {labelType.description}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>

      {/* Footer with build info */}
      <Box sx={styles.footer}>
        <Typography variant="caption" color="text.secondary" gutterBottom>
          Build commit: {getBuildCommit()}
        </Typography>
      </Box>
    </Box>
  );
};

const styles = createStyleSheet({
  pageBody: {
    ...globalStyles.flexColumn,
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    padding: 4,
  },
  labelTypesStack: {
    alignItems: "center",
    justifyContent: "space-evenly",
    marginTop: 5,
    width: "100%",
    flexWrap: "wrap",
    rowGap: 4,
  },
  buttonsBox: {
    ...globalStyles.flexColumn,
    alignItems: "center",
    gap: 3,
    width: "40%",
    minWidth: 20,
    textAlign: "center",
  },
  footer: {
    flexShrink: 0,
    padding: 2,
    textAlign: "center",
  },
});

export default LabelTypeSelect;
